import request from '@/request'
import axios from 'axios'
import type * as TYPE from './types'
import { useUserStore } from '@/stores/user'

// 跌倒统计
export const statsFallQuery = (
  params: TYPE.StatsFallQueryParams
): Promise<ResponseData<TYPE.StatsFallQueryData>> => {
  return request.post('/stats/fallQuery', params)
}

// 修改跌倒事件处理状态
export const statsFallUpdate = (
  params: TYPE.StatsFallUpdateParams
): Promise<ResponseData<TYPE.StatsFallUpdateData>> => {
  return request.post('/event/adminHandleFallEvent', params)
}
// 复核跌倒事件
export const statsFallReview = (params: {
  eventListId: ID
  reviewRemark: string | null // 复核备注
  checkIsHandle?: number // 是否复核：0-未复核，1-已复核
}): Promise<ResponseData<TYPE.StatsFallReviewData>> => {
  return request.post('/event/reviewFallingEvent', params)
}

// 告警统计
export const statsAlarmQuery = (
  params: TYPE.AtatsAlarmQueryParams
): Promise<ResponseData<TYPE.StatsAlarmQueryData>> => {
  return request.post('/stats/alarmEventsQuery', params)
}
// 跌倒历史统计
export const statsFallHistoryQuery = (
  params: TYPE.AtatsFallHistoryQueryParams
): Promise<ResponseData<TYPE.StatsFallHistoryData>> => {
  return request.post('/stats/fallQuery', params)
}

// 首页大屏统计
export const statsHomeScreenQuery = (params: {
  tenantId: string
}): Promise<ResponseData<TYPE.StatsHomeScreenQueryData>> => {
  return request.post('/stats/screen', params)
}

// 首页大屏历史跌倒统计
export const statsHomeScreenFallHistory = (params: {
  tenantId: string
  queryType: string // 查询类型 最近七天 day 最近半年 month
}): Promise<ResponseData<TYPE.StatsHomeScreenFallHistory>> => {
  return request.post('/stats/falling', params)
}

// 首页大屏历史告警统计
export const statsHomeScreenAlarmHistory = (params: {
  tenantId: string
  queryType: string // 查询类型 最近七天 day 最近半年 month
}): Promise<ResponseData<TYPE.StatsHomeScreenAlarmHistory>> => {
  return request.post('/stats/alarm', params)
}

// 设备上下线统计
export const statsDeviceOnlineQuery = (
  params: TYPE.StatsDeviceOnlineQueryParams
): Promise<ResponseData<TYPE.StatsDeviceOnlineQueryData>> => {
  return request.post('/stats/OnoffRecord', params)
}

// 历史进出统计
export const statsInoutHistoryQuery = (
  params: TYPE.StatsInoutHistoryQueryParams
): Promise<ResponseData<TYPE.StatsInoutHistoryQueryData>> => {
  return request.post('/stats/inOutEventQuery', params)
}

/* 智慧健康监测大屏 */
// 首页大屏统计
export const statsV2Screen = (params: {
  tenantId?: string
}): Promise<ResponseData<TYPE.StatsV2ScreenQueryData>> => {
  return request.post('/stats/v2/screen', params)
}

// 动态健康监测分析
export const statsV2Analyse = (params: {
  recentMonths: number
}): Promise<ResponseData<TYPE.statsV2AnalyseQueryData>> => {
  return request.post('/stats/v2/analyse', params)
}

// 动态信息展示
export const statsV2AlarmEventsQuery = (params: {
  createTimeStart?: string // 事件发生时间开始
  createTimeEnd?: string // 事件发生时间结束
}): Promise<ResponseData<TYPE.StatsV2AlarmEventsQueryData>> => {
  return request.post('/stats/v2/alarmEventsQuery', params)
}

// 地图区域数据显示
export const statsV2MapDisplay = (params: {
  code: string // 区域类型
  codeType: 'province' | 'city' | 'district' // 区域类型
}): Promise<ResponseData<TYPE.StatsV2MapDisplayQueryData>> => {
  return request.post('/stats/v2/mapDisplay', params)
}

//跌倒事件历史查询
// export const statsV2AlarmEventsQuery = (params: {
//   createTimeStart?: string // 事件发生时间开始
//   createTimeEnd?: string // 事件发生时间结束
// }): Promise<ResponseData<TYPE.StatsV2AlarmEventsQueryData>> => {
//   return request.post('/stats/v2/alarmEventsQuery', params)
// }

export const historyFallRecordQuery = (
  params: TYPE.historyFallParams
): Promise<ResponseData<TYPE.historyFallRecordQueryData>> => {
  return request.get('/oss/ws/play', { params })
}

/**
 * 跌倒事件导出
 */
export const fallEventExport = async (params: TYPE.fallEventExportParams): Promise<Blob> => {
  const instance = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL,
    timeout: 30000,
  })

  const userStore = useUserStore()
  const { tokenValue } = userStore.getUserInfo()

  if (tokenValue) {
    instance.defaults.headers.common['Authorization'] = `Bearer ${tokenValue}`
  }

  const response = await instance.post(`/stats/fallEventExport`, params, { responseType: 'blob' })
  return response.data
}
